var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"list-container",style:({gridTemplateColumns:`repeat(${_vm.cols},1fr)`,gap:_vm.gap+'px'})},_vm._l((_vm.data),function(o,i){return _c('div',{key:i,style:({gridColumn: i%_vm.cols+1,gridRow: Math.ceil((i+1)/_vm.cols)})},[_vm._t("default",null,{"item":o})],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }